import cntl from "cntl";
import Button from "./Button";
import PropTypes from "prop-types";
import { SIZE, POSITIONS } from "../constants/index";

const propTypes = {
  icon: PropTypes.object,
  name: PropTypes.string,
  type: PropTypes.string,
  onClick: PropTypes.func,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  className: PropTypes.string,
  iconPosition: PropTypes.oneOf([POSITIONS.left, POSITIONS.right]),
  buttonref: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  size: PropTypes.oneOf([SIZE.sm, SIZE.md, SIZE.lg, SIZE.xl, SIZE["2xl"]]),
};

function ButtonGroup({
  icon,
  name,
  type,
  label,
  onClick,
  disabled,
  buttonRef,
  className,
  isLoading,
  iconPosition,
  size = SIZE.md,
}) {
  const buttonCn = () => cntl`
    shadow-sm
    enabled:text-grey-700
    disabled:text-grey-300
    enabled:bg-white
    disabled:bg-white
    enabled:border-grey-300
    disabled:border-grey-300
    enabled:focus:bg-grey-50 enable:focus:border-grey-300
    enabled:hover:bg-grey-50 enabled:hover:border-grey-300
    ${className ? className : undefined}
  `;

  const iconCn = () => cntl`
    text-grey-500
    ${disabled ? cntl`text-grey-300` : cntl`text-grey-500`}
  `;

  return (
    <Button
      name={name}
      type={type}
      size={size}
      icon={icon}
      label={label}
      onClick={onClick}
      disabled={disabled}
      isLoading={isLoading}
      buttonRef={buttonRef}
      iconColor={iconCn()}
      className={buttonCn()}
      iconPosition={iconPosition}
    />
  );
}

ButtonGroup.propTypes = propTypes;
export default ButtonGroup;
